import type { PaginatedApi } from '@api/types';
import { getRequest } from '@helpers/api';

import type { ListEntitiesRequestPayload, EntityApiItem } from './types';

/**
 * List entities
 */
export const listEntities: PaginatedApi<ListEntitiesRequestPayload, EntityApiItem> = payload =>
  getRequest('auth/entity/', {
    limit: payload.limit,
    offset: payload.offset,
    ids: payload.ids,
  });
